import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    message,
    DatePicker,
    InputNumber,
    Pagination,
    Input,
    Modal,
    Spin,
    Empty,
    Select,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import { kindList } from "@/utils/constant";
import HandDetail from "@/pages/commom/HandDetail";

export default class IncomeRecord extends React.Component {
    state = {
        type: undefined, // 弹窗类型
        title: undefined, // 弹窗标题
        show: false, // 是否显示弹窗
        loading: false, // 是否加载中
        detailLoading: false, // 详情是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            vendor_id: undefined,
            member_id: undefined,
            kpoker_uid: undefined,
            act_type: undefined,
            date: [],
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
            mid: undefined,
        },
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        handCardData: {}, // 手牌详情
        kindList: kindList, // 游戏列表
        activeTypeList: [
            // 活动类型
            { value: 1, label: 'Luckycard' },
            { value: 2, label: 'Jackpot' },
        ],
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/gain_detail_log", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/union_game_detail", {
                params: {
                    ...this.state.detailQueryParams,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData: res.data || {},
                });
            });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        if (type === "handCard") {
            // 手牌详情
            this.setState(
                {
                    title: this.props.language["handDetail"],
                    type,
                    show: true,
                    selectedData: item,
                    handCardData: {},
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        mid: item.mid,
                        uid: undefined,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    vendor_id: undefined,
                    member_id: undefined,
                    kpoker_uid: undefined,
                    act_type: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Input
                        allowClear
                        placeholder={this.props.language["proxyIdPlaceholder"]}
                        value={this.state.queryParams.vendor_id}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("vendor_id", e.target.value)
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["memberIdPlaceholder"]}
                        value={this.state.queryParams.member_id}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("member_id", value)
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["kpokerPlayerIdPlaceholder"]}
                        value={this.state.queryParams.kpoker_uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("kpoker_uid", value)
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["activityTypePlaceholder"]}
                        value={this.state.queryParams.act_type}
                        onChange={(value) => this.handleSetQueryParamsData("act_type", value)}
                    >
                        {this.state.activeTypeList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="tunix"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.activeTypeList.find(
                                    (item2) => item2.value === item.act_type
                                )
                                    ? this.state.activeTypeList.find(
                                        (item2) => item2.value === item.act_type
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.kindList.find(
                                    (kindItem) => kindItem.value === item.kind
                                ) ? this.state.kindList.find(
                                    (kindItem) => kindItem.value === item.kind
                                ).label
                                    : ''
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ''}
                                </Link>
                            )}
                        />
                        {/* <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex=""
                            render={(item) => (
                                <Button
                                    type="link"
                                    onClick={() => this.handleShow("handCard", item)}
                                >
                                    {item.mid}
                                </Button>
                            )}
                        /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handId"]}
                            dataIndex="hid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["memberId"]}
                            dataIndex="member_uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["kpokerPlayerId"]}
                            dataIndex="kpoker_uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameNickname"]}
                            dataIndex="name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["income"]}
                            dataIndex="num"
                        />
                    </Table>
                    <Pagination
                        className="pagination"
                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>

                {/* 详情弹窗 */}
                <DetailModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    loading={this.state.detailLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.detailQueryParams.page,
                        pageSize: this.state.detailQueryParams.limit,
                        total: this.state.detailQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    selectedData={this.state.selectedData}
                    handCardData={this.state.handCardData}
                    detailQueryParams={this.state.detailQueryParams}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(pagination) =>
                        this.hanldeChangePage(
                            { current: pagination },
                            "handCard"
                        )
                    }
                />
            </div>
        );
    }
}

/**
 * 详情弹窗
 */
class DetailModal extends React.Component {
    render () {
        let handCardTitle = (
            <div className='container-header p0'>
                {this.props.handCardData.hand_time && (
                    <>
                        <span>{this.props.title}</span>
                        <span>（{this.props.handCardData.id}）</span>
                        <span className="mr20">
                            {this.props.handCardData.hand_time
                                ? this.props.handCardData.hand_time
                                : ""}
                        </span>
                    </>
                )}
                <InputNumber
                    precision={0}
                    min={0}
                    max={100000000}
                    placeholder={this.props.language["playerIdPlaceholder"]}
                    value={this.props.detailQueryParams.uid}
                    onChange={(value) =>
                        this.props.handleSetQueryParamsData("uid", value, "handCard")
                    }
                />
            </div>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={
                    this.props.type === "handCard" ? handCardTitle : this.props.title
                }
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                    overflowY: "auto",
                }}
                footer={
                    this.props.type === "handCard" ? (
                        <Pagination
                            showQuickJumper
                            {...this.props.pagination}
                            showTotal={(total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                            }
                            size={isMobileDevice() ? 'small' : ''}
                            onChange={this.props.onChange}
                        />
                    ) : null
                }
            >
                <div className="container-content">
                    {/* 手牌详情 */}
                    {this.props.type === "handCard" && (
                        <Spin spinning={this.props.loading}>
                            {this.props.handCardData.id && (
                                <>
                                    {/* NLH, AOF, PLO, AOF */}
                                    <HandDetail
                                        {...this.props}
                                        handCardData={this.props.handCardData}
                                        squidConf={this.props.selectedData.squid_conf}
                                        searchPlayer={{
                                            uid1: this.props.detailQueryParams.uid,
                                        }}
                                    />
                                </>
                            )}

                            {/* 暂无数据 */}
                            {!this.props.handCardData.id && (
                                <>
                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                </>
                            )}
                        </Spin>
                    )}
                </div>
            </Modal>
        );
    }
}

